import PropTypes from "prop-types";
import classNames from "classnames";
import { ButtonStyle } from "../../js/enums";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Button({
  className,
  disabled,
  icon,
  isBlock = false,
  onClick,
  showSpinner = false,
  style = ButtonStyle.Info,
  text,
  type = "button",
}) {
  return (
    <button
      onClick={onClick}
      type={type}
      className={classNames(
        "btn",
        "position-relative",
        style,
        isBlock ? "btn-block" : "",
        className
      )}
      disabled={disabled}
    >
      {showSpinner && (
        <div className="position-absolute top-50 start-50 translate-middle">
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </div>
      )}
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={classNames(
            text ? "me-2" : "",
            showSpinner ? "opacity-25" : ""
          )}
        />
      )}
      <span className={showSpinner ? "opacity-25" : ""}>{text}</span>
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isBlock: PropTypes.bool,
  onClick: PropTypes.func,
  showSpinner: PropTypes.bool,
  style: PropTypes.string,
  text: PropTypes.node,
  type: PropTypes.string,
};

export default Button;
